import randysWorldwideDefaults from '../randys-worldwide/config.js';
import { initHelpers } from '../randys-worldwide/helpers.js';

randysWorldwideDefaults.Widgets.find((w) => w.name === 'HomeVehicleWidget').isAlwaysColumnLayout = false;
randysWorldwideDefaults.Widgets.find((w) => w.name === 'HomeVehicleWidget').columnBreakpoint = 1000;

initHelpers({ YMMTabSelector: 'tab-shop-by-vehicle' });

// the Wheels collection is sorted by Newest first, other pages keep the store's custom sort rules
const isWheelsCollectionPage = window.location.pathname === '/collections/wheels';

export default {
  ...randysWorldwideDefaults,
  includes: ['shopify-generic', 'randys-worldwide'],
  SearchRequestDefaults: {
    pageSize: 24,
    sort: isWheelsCollectionPage ? 'published_at:desc' : undefined,
  },
  Widgets: [
    ...randysWorldwideDefaults.Widgets.filter((w) => w.name !== 'MobileGarageDialogButton'),
    {
      name: 'GarageListDialog',
      type: 'ContextDialog',
      template: 'fitmentSearch/garageListDialog',
    },
    {
      name: 'GarageListDialogContent',
      type: 'VehicleList',
      doNotRedirectOnVehicleSelect: true,
    },
    {
      name: 'MobileGarageDialogButton',
      type: 'DialogButton',
      location: { selector: '#cm-mobile-garage', class: 'cm_garage__mobile' },
      template: 'fitmentSearch/mobileGarage',
      dialogName: 'GarageListDialog',
    },
  ],
};
